// extracted by mini-css-extract-plugin
module.exports = {"reportHeader":"ReportHeader_reportHeader__1IDIS"};